import Phaser from "phaser";
import { GAME_WIDTH, GAME_HEIGHT } from "./Config";
import { PlayScene } from "../scenes/PlayScene";
import { ResultScene } from "../scenes/ResultScene";

export class GameApp {
  game: Phaser.Game;

  constructor() {
    this.game = new Phaser.Game({
      type: Phaser.AUTO,
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
      backgroundColor: "#1a1a2e",
      parent: document.body,
      scene: [PlayScene, ResultScene],
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
    });
  }
}
